// extracted by mini-css-extract-plugin
export default {"products":"er-z","card":"fr-z","oosMessaging":"gr-z"};